import gql from 'graphql-tag'

export const AUDIT = gql`
  fragment Audit on Audit {
    id
    user {
      ... on User {
        id
        name
      }
    }
    auditable {
      __typename # just to be sure, we will load this here to
    }
    event
    old_values
    new_values
    tags
    created_at
    updated_at
  }
`
